import { render, staticRenderFns } from "./PartBasePartyB.vue?vue&type=template&id=b0f7275e&scoped=true"
import script from "./PartBasePartyB.vue?vue&type=script&lang=js"
export * from "./PartBasePartyB.vue?vue&type=script&lang=js"
import style0 from "./PartBasePartyB.vue?vue&type=style&index=0&id=b0f7275e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f7275e",
  null
  
)

export default component.exports